const networkHelper = () => {
  const isSuccess = (status) => {
    return status >= 200 && status <= 299;
  };

  return {
    isSuccess,
  };
};

export default networkHelper;
